/**
 * React component that displays a static image as a background.
 */

import React from 'react'

const Background = props => {
  if (!props.filename) {
    return null
  }
  return (
    <img
      alt={props.alt || ``}
      className={`image-wrapper`}
      src={`/images/${props.filename}`}
      style={{
        position: `absolute`,
        right: 0,
        left: 0,
        top: 0,
        bottom: 0,
        objectFit: `cover`,
        objectPosition: `50% 50%`,
        width: `100%`,
        height: `100%`,
        minHeight: `100%`,
      }}
    />
  )
}

export default Background
